import I18n from 'lib/i18n'
import React from 'react'
import { useActions, useValues } from 'kea'

import Checkbox from 'lib/forms/checkbox-svg'

import filtersLogic from '~/scenes/search/filters-page/logic'

const translations = {
  infant: I18n.t('react.search.filters.age.infant'),
  preschool: I18n.t('react.search.filters.age.preschool'),
  child: I18n.t('react.search.filters.age.child'),
  teenager: I18n.t('react.search.filters.age.teenager'),
  adult: I18n.t('react.search.filters.age.adult'),
  senior: I18n.t('react.search.filters.age.senior')
}

export default function Age () {
  const { unsavedFilter } = useValues(filtersLogic)
  const { updateUnsavedFilter } = useActions(filtersLogic)

  const ages = unsavedFilter.ages.split(',')

  function toggleAge (age) {
    if (ages.indexOf(age) > -1) {
      updateUnsavedFilter({ ages: ages.filter(v => v !== age).join(',') })
    } else {
      updateUnsavedFilter({ ages: [...ages, age].join(',') })
    }
  }

  return (
    <div className='filter-section'>
      <div className='filter-title'>{I18n.t('activerecord.attributes.message.student_age')}</div>
      <div className='checkbox-list'>
        {Object.keys(translations).map(age => (
          <Checkbox key={`age-element-${age}`} checked={ages.indexOf(age) >= 0} onChange={() => toggleAge(age)}>
            {translations[age]}
          </Checkbox>
        ))}
      </div>
    </div>
  )
}
